@for (chart of charts; track $index; let isLast=$last) {
  <div class="chart-container">
    <div class="chart-title">
      <span class="chart-text">
        <span>{{chart.title}}</span>
      </span>
    </div>
    <div class="chart-canvas-container" style="position: relative; height:55vh; width:100%">
      <canvas baseChart
        [data]="chart.data"
        [options]="chart.options"
        [plugins]="chart.plugins"
        [legend]="chart.legend"
        [type]="chart.type">
      </canvas>
    </div>
  </div>
}
